/* ============================================
   coffret.js - Maison Ben Nasr
   Emplacement : assets/coffret.js
   ============================================ */

var MBN_CONFIG = {
  variants: {
    6:  57808672817416,
    12: 57808692543752,
    24: 57808692576520
  },
  prices: {
    6:  15,
    12: 29,
    24: 55,
  },
  flavors: [
    { id: 'pistache',      name: 'Pistache',      color: '#C8D5A3' },
    { id: 'noisette',      name: 'Noisette',       color: '#C9956C' },
    { id: 'pistache-pure', name: 'Pistache Pure',  color: '#B7C78A' },
    { id: 'noisette-pure', name: 'Noisette Pure',  color: '#B9855D' },
    { id: 'speculoos',     name: 'Speculoos',      color: '#D4B483' },
    { id: 'coco',          name: 'Coco',           color: '#EDE8DC' },
    { id: 'sesame',        name: 'Sesame',         color: '#C4B98A' },
    { id: 'cacahuete',     name: 'Cacahuete',      color: '#C4A882' },
    { id: 'cafe',          name: 'Cafe',           color: '#6B4A34' }
  ]
};

/* --- ETAT ---------------------------------- */
var state = {
  boxSize: 6,
  counts: {
    'pistache': 0,
    'noisette': 0,
    'pistache-pure': 0,
    'noisette-pure': 0,
    'speculoos': 0,
    'coco': 0,
    'sesame': 0,
    'cacahuete': 0,
    'cafe': 0
  }
};

function totalSelected() {
  var total = 0;
  MBN_CONFIG.flavors.forEach(function(f) {
    total += state.counts[f.id] || 0;
  });
  return total;
}

/* --- INIT ---------------------------------- */
document.addEventListener('DOMContentLoaded', function() {
  initSizeButtons();
  initFlavorCards();
  initGiftToggle();
  initForm();
  initReset();
  render();
});

/* --- TAILLE -------------------------------- */
function initSizeButtons() {
  var btns = document.querySelectorAll('.size-btn');
  btns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var newSize = parseInt(btn.getAttribute('data-size'), 10);
      if (newSize === state.boxSize) return;
      state.boxSize = newSize;

      // Tronquer si trop de samsas selectionnes
      var total = totalSelected();
      if (total > state.boxSize) {
        var toRemove = total - state.boxSize;
        MBN_CONFIG.flavors.forEach(function(f) {
          if (toRemove <= 0) return;
          var remove = Math.min(state.counts[f.id] || 0, toRemove);
          state.counts[f.id] -= remove;
          toRemove -= remove;
        });
      }

      btns.forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      render();
    });
  });
}

/* --- SAVEURS ------------------------------- */
function initFlavorCards() {
  // Clic sur carte = ajouter
  document.querySelectorAll('.flavor-card').forEach(function(card) {
    if (card.dataset.initialized) return;
card.dataset.initialized = 'true';

card.addEventListener('click', function(e) {
      if (e.target.classList.contains('flavor-plus') ||
          e.target.classList.contains('flavor-minus')) return;
      var id = card.getAttribute('data-flavor');
      addFlavor(id);
    });
  });

  // Bouton +
  document.querySelectorAll('.flavor-plus').forEach(function(btn) {
    if (btn.dataset.initialized) return;
btn.dataset.initialized = 'true';

btn.addEventListener('click', function(e) {
      e.stopPropagation();
      addFlavor(btn.getAttribute('data-flavor'));
    });
  });

  // Bouton -
  document.querySelectorAll('.flavor-minus').forEach(function(btn) {
    if (btn.dataset.initialized) return;
    btn.dataset.initialized = 'true';
    
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      removeFlavor(btn.getAttribute('data-flavor'));
    });
  });
}

function addFlavor(id) {
  if (totalSelected() >= state.boxSize) return;
  state.counts[id] = (state.counts[id] || 0) + 1;
  render();
}

function removeFlavor(id) {
  if (!state.counts[id] || state.counts[id] <= 0) return;
  state.counts[id]--;
  render();
}

/* --- MESSAGE CADEAU ------------------------ */
function initGiftToggle() {
  var toggle   = document.getElementById('gift-toggle');
  var textarea = document.getElementById('gift-message');
  if (!toggle || !textarea) return;
  toggle.addEventListener('change', function() {
    textarea.style.display = toggle.checked ? 'block' : 'none';
    if (!toggle.checked) textarea.value = '';
  });
}

/* --- FORMULAIRE ---------------------------- */
function initForm() {
  var form = document.getElementById('coffret-form');
  if (!form) return;
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    if (totalSelected() !== state.boxSize) return;

    var variantId = MBN_CONFIG.variants[state.boxSize];
    if (!variantId) {
      showNotif('ID produit manquant - voir coffret.js');
      return;
    }

    var textarea  = document.getElementById('gift-message');
    var varInput  = document.getElementById('variant-id');
    var savInput  = document.getElementById('input-saveurs');
    var msgInput  = document.getElementById('input-message');

    if (varInput) varInput.value = variantId;
    if (savInput) savInput.value = buildSaveursString();
    if (msgInput) msgInput.value = textarea ? textarea.value : '';

addToCartAjax({
   id: variantId,
   quantity: 1,
   properties: {
     'Coffret': state.boxSize + ' samsas',
     'Saveurs': buildSaveursString(), 
     'Message cadeau': textarea ? textarea.value : '' 
    } 
  }); 
}); 
}

/* --- RESET --------------------------------- */
function initReset() {
  var btn = document.getElementById('btn-reset');
  if (!btn) return;
  btn.addEventListener('click', function() {
    MBN_CONFIG.flavors.forEach(function(f) { state.counts[f.id] = 0; });
    render();
  });
}

/* --- AJAX PANIER --------------------------- */
function addToCartAjax(payload) {
  console.log('Payload envoyé :', payload);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(payload)
  })
  .then(function(res) {
    return res.json().then(function(data) {
      if (!res.ok) {
        throw new Error(data.description || 'Erreur Shopify');
      }

      console.log('Réponse Shopify :', data);

      showNotif('Coffret ajoute au panier !');

if (window.Shopify && Shopify.designMode) {

  console.log('Ajout panier OK');

} else {

  setTimeout(function() {
    window.location.href = '/cart';
  }, 800);

}

      setTimeout(function() {
        MBN_CONFIG.flavors.forEach(function(f) {
          state.counts[f.id] = 0;
        });

        render();
      }, 1200);
    });
  })
  .catch(function(err) {
    console.error('[MBN] Erreur panier :', err);
    showNotif(err.message || 'Erreur panier');
  });
}

/* --- RENDER -------------------------------- */
function render() {
  renderCards();
  renderBoxPreview();
  renderProgress();
  renderSummary();
  renderCartButton();
}

function renderCards() {
  var total = totalSelected();
  var full  = total >= state.boxSize;

  MBN_CONFIG.flavors.forEach(function(f) {
    var card    = document.querySelector('.flavor-card[data-flavor="' + f.id + '"]');
    var counter = document.getElementById('counter-' + f.id);
    var actions = document.getElementById('actions-' + f.id);
    var qty     = document.getElementById('qty-' + f.id);
    var plusBtn = card ? card.querySelector('.flavor-plus') : null;
    var count   = state.counts[f.id] || 0;
    if (!card) return;

    card.classList.toggle('selected', count > 0);
    card.classList.toggle('disabled', full && count === 0);
    card.setAttribute('aria-pressed', count > 0 ? 'true' : 'false');

    if (counter) {
      counter.textContent = count;
      counter.style.display = count > 0 ? 'flex' : 'none';
    }
    if (actions) actions.style.display = count > 0 ? 'flex' : 'none';
    if (qty)     qty.textContent = count;
    if (plusBtn) plusBtn.disabled = full;
  });
}

function renderBoxPreview() {
  var preview = document.getElementById('box-preview');
  if (!preview) return;
  preview.innerHTML = '';

  var cols = state.boxSize <= 6 ? 3 : state.boxSize <= 12 ? 4 : 6;
  preview.style.display = 'grid';
  preview.style.gridTemplateColumns = 'repeat(' + cols + ', 1fr)';

  var selected = [];
  MBN_CONFIG.flavors.forEach(function(f) {
    for (var i = 0; i < (state.counts[f.id] || 0); i++) {
      selected.push(f);
    }
  });

  for (var i = 0; i < state.boxSize; i++) {
    var slot = document.createElement('div');
    slot.className = 'box-slot';
    if (selected[i]) {
      slot.style.borderBottomColor = selected[i].color;
      slot.classList.add('filled');
      slot.title = selected[i].name;
    }
    preview.appendChild(slot);
  }
}

function renderProgress() {
  var total = totalSelected();
  var pct   = Math.round((total / state.boxSize) * 100);
  var fill  = document.getElementById('progress-fill');
  var label = document.getElementById('progress-label');
  var hint  = document.getElementById('step-hint');
  if (fill)  fill.style.width = pct + '%';
  if (label) label.textContent = total + ' / ' + state.boxSize + ' samsas choisis';
  if (hint)  hint.textContent  = '- ' + (state.boxSize - total) + ' restant(s)';
}

function renderSummary() {
  var list  = document.getElementById('summary-list');
  var price = document.getElementById('total-price');
  if (!list) return;

  var total = totalSelected();
  if (total === 0) {
    list.innerHTML = '<p class="summary-empty">Aucune saveur selectionnee</p>';
    if (price) price.textContent = '-';
    return;
  }

  var html = '';
  MBN_CONFIG.flavors.forEach(function(f) {
    var count = state.counts[f.id] || 0;
    if (count === 0) return;
    html += '<div class="summary-line">'
      + '<span class="summary-line-name">' + f.name + '</span>'
      + '<span class="summary-line-qty">x' + count + '</span>'
      + '</div>';
  });
  list.innerHTML = html;

  if (price) {
    price.textContent = total === state.boxSize
      ? MBN_CONFIG.prices[state.boxSize] + ' EUR'
      : '-';
  }
}

function renderCartButton() {
  var btn = document.getElementById('btn-cart');
  if (!btn) return;
  var total    = totalSelected();
  var complete = total === state.boxSize;
  var remaining = state.boxSize - total;
  btn.disabled = !complete;
  btn.textContent = complete
    ? 'Ajouter au panier - ' + MBN_CONFIG.prices[state.boxSize] + ' EUR'
    : 'Choisis encore ' + remaining + ' samsa' + (remaining > 1 ? 's' : '');
}

/* --- UTILITAIRES --------------------------- */
function buildSaveursString() {
  var parts = [];
  MBN_CONFIG.flavors.forEach(function(f) {
    var count = state.counts[f.id] || 0;
    if (count > 0) parts.push(count + 'x ' + f.name);
  });
  return parts.join(', ');
}

function showNotif(message) {
  var notif = document.querySelector('.coffret-notif');
  if (!notif) {
    notif = document.createElement('div');
    notif.className = 'coffret-notif';
    document.body.appendChild(notif);
  }
  notif.textContent = message;
  notif.classList.add('show');
  setTimeout(function() { notif.classList.remove('show'); }, 3000);
}